<template>
  <div id="button-group">
    <img class="cancel btn" src="../../assets/img/cancelButton.svg" alt="cancel" />
    <img class="ok btn" src="../../assets/img/okButton.svg" alt="cancel" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
#button-group {
  display: flex;
  width: 70vw;
  justify-content: space-evenly;
  margin: 10vh auto 0 auto;
}
</style>
